import React from "react";

const Project = () => {
  return (
    <div>
      <h3 class="text-xl font-bold">Projects</h3>
      <div class="mt-3 space-y-4">
        <div class="checkbox-container">
          <input type="checkbox" class="color-scoreboard" checked />
          <p class="label">Scoreboard</p>
        </div>
      </div>
    </div>
  );
};

export default Project;
